<template>
    <div>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="isShown"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detai Import Shift {{ data.nama }} - {{ data.nip }}</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closePopUp()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding: 24px">
                    <CRow>
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="2">
                                    Total Data Shift
                                </CCol>
                                <CCol sm="1" class="text-right">:</CCol>
                                <CCol sm="3" class="font-weight-bold">{{ data.totalJadwal + ' Data' }}</CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="2">
                                    Total Data Sukses
                                </CCol>
                                <CCol sm="1" class="text-right">:</CCol>
                                <CCol sm="3" style="color:green" class="font-weight-bold">{{ data.totalSuccess + ' Data' }}</CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="2">
                                    Total Data Gagal
                                </CCol>
                                <CCol sm="1" class="text-right">:</CCol>
                                <CCol sm="3" style="color:red" class="font-weight-bold">{{ data.totalError + ' Data' }}</CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow class="mt-4">
                        <CCol sm="12">
                            <Tables :data="data.detailJadwal" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>

<script>
import Tables from '../../../component/tableShiftDetail'
export default {
    components: {
        Tables
    },
    data() {
        return {
            loading: false,
            loadingUpload: false,
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            isShown: false,
            data: [],
            dataTh: [
                'Tanggal',
                'Jam Kerja',
                'Istirahat',
                'Status',
                'Keterangan'
            ],
            dataTd: [
                'tanggal',
                'jamKerja',
                'istirahat',
                'isSuccess',
                'deskripsi'
            ],
            styleTable: ['50px', '75px', '75px', '50px', '200px'],
            errorMessage: '',
        }
    },
    methods: {
        closePopUp() {
            this.data = []
            this.isShown = false
        }
    },
    watch: {
    },
    mounted() {
    },
}
</script>
<style scoped>
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
</style>